/**
 * Audiência da lista ecommerce (quem o operador está vendo).
 * Separado do filtro de transação (pipeline documental).
 */

export type EcommerceListAudience =
  | "transactions"
  | "consent_patients"
  | "registered_clients";

export const DEFAULT_ECOMMERCE_LIST_AUDIENCE: EcommerceListAudience =
  "transactions";

export const ECOMMERCE_LIST_AUDIENCE_OPTIONS: Array<{
  id: EcommerceListAudience;
  label: string;
  description: string;
}> = [
  {
    id: "transactions",
    label: "Transações",
    description: "Todas as transações dos pacientes com consentimento.",
  },
  {
    id: "consent_patients",
    label: "Pacientes com consentimento",
    description: "Quem autorizou a loja a ver documentos e pedidos.",
  },
  {
    id: "registered_clients",
    label: "Clientes cadastrados",
    description: "Quem foi cadastrado nesta loja.",
  },
];

const AUDIENCE_IDS = new Set<EcommerceListAudience>(
  ECOMMERCE_LIST_AUDIENCE_OPTIONS.map((option) => option.id),
);

export function isEcommerceListAudience(
  value: string,
): value is EcommerceListAudience {
  return AUDIENCE_IDS.has(value as EcommerceListAudience);
}

export function getEcommerceAudienceNoun(
  audience: EcommerceListAudience,
  count: number,
): string {
  if (audience === "transactions") {
    return count === 1 ? "transação" : "transações";
  }
  if (audience === "consent_patients") {
    return count === 1 ? "paciente" : "pacientes";
  }
  return count === 1 ? "cliente" : "clientes";
}
